"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SlackGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__slack-green-multitone-filled__clip0_13467_82)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M10.015 7.481c-.798 0-1.476-.638-1.476-1.436v-4.19A1.43 1.43 0 019.975.42a1.43 1.43 0 011.437 1.436v4.15c.08.798-.599 1.476-1.397 1.476zM.399 5.965c0-.798.638-1.476 1.476-1.476h4.11c.798 0 1.476.638 1.476 1.476 0 .798-.638 1.476-1.476 1.476h-4.11C1.037 7.401.4 6.763.4 5.965zM.918 9.796c0-.56.479-1.038 1.037-1.038h1.277c.04 0 .04 0 .04.04v1.277c0 .558-.479 1.037-1.038 1.037-.758 0-1.316-.558-1.316-1.316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M10.653.539L8.58 2.853v-.998A1.43 1.43 0 0110.015.42h.04c.2 0 .399.04.598.12zM6.823 4.768L4.469 7.402H1.835A1.43 1.43 0 01.4 5.965 1.43 1.43 0 011.835 4.53h4.15c.32-.04.599.08.838.24.04 0 .04 0 0 0zM3.232 8.798l-1.835 2.035a1.266 1.266 0 01-.52-1.037v-.04c0-.559.44-.998.998-.998l1.357.04s0-.04 0 0zM7.302 1.975v1.317H5.985a.988.988 0 01-.997-.998c0-.758.598-1.356 1.356-1.356.479.04.958.478.958 1.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M10.055 7.88h-.08A1.83 1.83 0 018.14 6.045v-4.19C8.18.818 8.978.02 9.975.02h.08a1.83 1.83 0 011.835 1.835v4.23c0 .957-.838 1.795-1.835 1.795zM9.975.818c-.559 0-1.037.479-1.037 1.037v4.23c0 .558.478 1.037 1.037 1.037h.08c.559 0 1.037-.479 1.037-1.037v-4.23c0-.558-.479-1.037-1.037-1.037h-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M5.985 15.581h-.08a1.43 1.43 0 01-1.436-1.436v-4.19A1.43 1.43 0 015.905 8.52h.08a1.43 1.43 0 011.436 1.436v4.23c-.04.758-.678 1.396-1.436 1.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M5.985 15.98h-.08a1.83 1.83 0 01-1.835-1.835v-4.19A1.83 1.83 0 015.905 8.12h.08A1.83 1.83 0 017.82 9.955v4.23c-.04.997-.837 1.795-1.835 1.795zm-.08-7.062c-.558 0-1.037.479-1.037 1.037v4.23c0 .558.479 1.037 1.037 1.037h.08c.559 0 1.037-.479 1.037-1.037v-4.23c0-.558-.478-1.037-1.037-1.037h-.08zM9.815 15.062h-.04a1.03 1.03 0 01-1.037-1.037v-1.317h1.317a1.03 1.03 0 011.037 1.038v.04a1.26 1.26 0 01-1.277 1.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M9.815 15.461h-.04c-.797 0-1.396-.638-1.396-1.436v-1.716h1.716a1.43 1.43 0 011.436 1.437v.04c-.04.917-.798 1.675-1.716 1.675zm-.678-2.354v.958c0 .359.28.638.599.638h.04a.886.886 0 00.877-.877v-.04a.63.63 0 00-.638-.639h-.878v-.04zM8.499 10.075v-.08a1.43 1.43 0 011.436-1.436h4.23A1.43 1.43 0 0115.6 9.995v.08a1.43 1.43 0 01-1.436 1.436h-4.23A1.43 1.43 0 018.5 10.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M14.125 11.91h-4.19A1.83 1.83 0 018.1 10.075v-.08A1.83 1.83 0 019.935 8.16h4.23A1.83 1.83 0 0116 9.995v.08c-.04.997-.878 1.835-1.875 1.835zm-4.19-2.912c-.558 0-1.037.478-1.037 1.037v.08c0 .558.479 1.037 1.037 1.037h4.23c.558 0 1.037-.479 1.037-1.037v-.12c0-.559-.479-1.037-1.037-1.037h-4.23v.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M6.025 7.8h-4.19C.798 7.8 0 7.002 0 6.005v-.08A1.83 1.83 0 011.835 4.09h4.23A1.83 1.83 0 017.9 5.925v.08A1.884 1.884 0 016.025 7.8zm-4.19-2.912c-.558 0-1.037.479-1.037 1.037v.08c0 .559.479 1.037 1.037 1.037h4.23c.558 0 1.037-.478 1.037-1.037v-.08c0-.558-.479-1.037-1.037-1.037h-4.23zM2.234 11.511h-.04A1.686 1.686 0 01.52 9.835v-.04A1.43 1.43 0 011.955 8.36h1.716V10.075a1.43 1.43 0 01-1.437 1.436zm-.319-2.354a.63.63 0 00-.638.639v.04c0 .478.399.877.878.877h.04a.63.63 0 00.638-.638v-.958h-.918v.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M15.042 6.165v.04a1.03 1.03 0 01-1.037 1.037h-1.317V5.925a1.03 1.03 0 011.038-1.037h.04a1.26 1.26 0 011.276 1.277z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M14.045 7.64h-1.716V5.926a1.43 1.43 0 011.437-1.436h.04c.917 0 1.675.758 1.675 1.676v.04c-.04.797-.678 1.436-1.436 1.436zm-.958-.797h.958c.359 0 .598-.28.598-.639v-.04a.886.886 0 00-.877-.877h-.04a.63.63 0 00-.639.638v.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M7.262 3.73H5.945c-.798 0-1.396-.638-1.396-1.436v-.04c0-.917.758-1.675 1.675-1.675h.04a1.43 1.43 0 011.437 1.436v1.716h-.44zM6.224 1.378a.886.886 0 00-.877.877v.04c0 .36.279.639.598.639h.958v-.958a.63.63 0 00-.639-.638h-.04v.04z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__slack-green-multitone-filled__clip0_13467_82"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

SlackGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SlackGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SlackGreenMultitoneFilled;
exports["default"] = _default;